import {SMALL} from './BreakPoints.js'
/*
    Responsive props to hold all the props relevant for device info and layout
    Immediate extension with spacing for Desktop and mobile
*/
export const responsiveProps = {

    isMobile : {
        default : false,
        [SMALL] : true
    },
    spacingInset_shorthand2 : {
        default : "medium large",
        [SMALL] : "medium large medium none",
    },
    spacingInset_shorthand3 : {
        default : "small",
        [SMALL] : "none"
    },
    spacingInset_shorthand4 : {
        default : "small large",
        [SMALL] : "none",
    },
    spacingInset_shorthand5 : {
        default : "small large",
        [SMALL] : "small medium",
    },
    spacingInset_shorthand6 : {
        default : "none medium none large",
        [SMALL] : "small small none small",
    },
}


// WEBPACK FOOTER //
// ./src/components/common/constant/ResponsiveProps.js